<template>
  <div class="service">
    <div class="service-head">
      <div class="service-head-l">{{ $t('checkout.selectOrderType') }}</div>
      <div v-if="showChangeBtn" class="service-head-r" @click="showChange">
        {{ $t('checkout.changeOption') }}
      </div>
    </div>
    <div v-if="!scheduled" class="service-value">
      {{ SERVICE_MAP[serviceType] }}
    </div>
    <div v-else class="service-value">
      <div>
        {{
          serviceType === 'PICK_UP'
            ? $t('checkout.scheduleTypePickup')
            : $t('checkout.scheduleTypeDelivery')
        }}
      </div>
      <div v-if="timesStr" class="font-size-12 text-theme-gray">
        <span>
          {{
            serviceType === 'PICK_UP'
              ? $t('checkout.timePickup')
              : $t('checkout.timeDelivery')
          }}
          {{ timesStr || '' }}
        </span>
      </div>
    </div>

    <!-- 这里需要加判断 UserInfo -->
    <template v-if="scheduled">
      <div
        class="user-address-confirm text-indigo-9 text-weight-bold"
        @click="$refs.picker.show = true"
      >
        {{
          timesStr
            ? $t('checkout.changeTime')
            : $t('checkout.setTime', { type: SERVICE_MAP[serviceType] })
        }}
      </div>
      <div v-if="!timesStr" class="user-address-tip text-negative">
        <q-icon name="font:dm-warning" />
        {{
          $t('checkout.timeTips', {
            type: SERVICE_MAP[serviceType],
            idType: serviceType === 'PICK_UP' ? 'pengambilan' : 'pengiriman',
          })
        }}
      </div>
    </template>
    <SchedulePicker ref="picker" :value="pickDate" @confirm="selectTime" />
    <q-dialog
      v-model="show"
      position="bottom"
      @show="tempService = serviceType"
    >
      <q-card class="types">
        <div class="types-head">
          <span>{{ $t('checkout.changeTypeDialogTitle') }}</span>
          <q-icon v-close-popup name="svg:oclose" class="type-close" />
        </div>
        <div class="types-body">
          <div
            v-for="it of serviceTypes"
            :key="it.id"
            class="types-body-item"
            :class="{ disabled: isClose }"
            @click="chooseType(it.id, false)"
          >
            <span
              class="types-body-icon"
              :class="{
                active: it.id === tempService && !tempSchedule,
              }"
            />
            <span>{{ it.value }}</span>
          </div>
          <!-- Schedule -->
          <template v-if="scheduledData && scheduledData.scheduledEnable">
            <!-- Schedule Pick-up -->
            <div
              v-if="scheduledData.scheduledPickUp"
              class="types-body-item"
              @click="chooseType('PICK_UP', true)"
            >
              <span
                class="types-body-icon"
                :class="{ active: tempService === 'PICK_UP' && tempSchedule }"
              />
              <span>{{ $t('checkout.schedulePickup') }}</span>
            </div>
            <!-- Schedule Delivery -->
            <div
              v-if="scheduledData.scheduledDelivery"
              class="types-body-item"
              @click="chooseType('DELIVERY', true)"
            >
              <span
                class="types-body-icon"
                :class="{ active: tempService === 'DELIVERY' && tempSchedule }"
              />
              <span>{{ $t('checkout.scheduleDelivery') }}</span>
            </div>
          </template>
        </div>
        <div class="types-footer">
          <button @click="onConfirm">{{ $t('checkout.continue') }}</button>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SchedulePicker from './SchedulePickerDialog/index.vue';

export default {
  components: {
    SchedulePicker,
  },
  inject: ['refresh'],
  data() {
    return {
      tempService: '',
      show: false,
      tempSchedule: false,
      pickDate: {
        left: {},
        right: {},
      },
      timesStr: '',
      timeStamp: 0,
    };
  },
  computed: {
    ...mapState({
      isClose: (state) => state.prefetch.storeInfo?.status?.statusCode !== 200,
      SERVICE_MAP: (state) => ({
        PICK_UP: state.prefetch.storeInfo.customize.PICK_UP,
        DINE_IN: state.prefetch.storeInfo.customize.DINE_IN,
        DELIVERY: state.prefetch.storeInfo.customize.DELIVERY,
      }),
      serviceType: (state) => state.Menu.accessStatus,
      serviceTypes(state) {
        const hideDine = (k) => k !== 'FULL_DINE_IN';
        return Object.keys(state.prefetch.storeInfo.service)
          .filter(
            (key) => state.prefetch.storeInfo.service[key] && hideDine(key),
          )
          .map((key) => ({ id: key, value: this.SERVICE_MAP[key] }));
      },
      scheduled: (state) => state.Menu.scheduled,
      scheduledTime: (state) => state.Menu.scheduledTime,
      scheduledData: (state) => state.prefetch.storeInfo.scheduled,
    }),
    showChangeBtn() {
      const {
        scheduledPickUp,
        scheduledDineIn,
        scheduledDelivery,
        scheduledEnable,
      } = this.scheduledData || {};
      if (scheduledEnable) {
        const normalNum = this.serviceTypes.length;
        const scheduledNum = [
          scheduledPickUp,
          scheduledDineIn,
          scheduledDelivery,
        ].filter(Boolean).length;
        return normalNum + scheduledNum > 1;
      }
      return this.serviceTypes.length > 1;
    },
  },
  methods: {
    showChange() {
      this.show = true;
      this.tempSchedule = this.scheduled;
    },
    chooseType(type, isSchedule) {
      this.tempService = type;
      this.tempSchedule = isSchedule;
    },
    resetDate() {
      this.$store.dispatch('Menu/resetSchedule');
      this.timesStr = '';
      this.pickDate = {
        left: {},
        right: {},
      };
    },
    onConfirm() {
      this.show = false;
      // 切换服务模式，清空scheduled数据
      this.resetDate();
      const confirmData = { from: this.serviceType, to: this.tempService };
      if (this.scheduled !== this.tempSchedule) {
        this.$store.commit('Menu/updateScheduled', this.tempSchedule);
      }
      if (this.serviceType !== this.tempService) {
        this.$store.commit('Menu/updateAccessStatus', this.tempService);
      }
      // TODO: 需要校验优惠券
      this.$emit('onConfirm', confirmData);
    },
    onCheckTime() {
      return this.$refs.picker.onCheckOrderTime();
    },
    selectTime(data) {
      this.pickDate = JSON.parse(JSON.stringify(data));
      this.timesStr = data.label;
      this.timeStamp = data.timestemp;
      this.$store.commit('Menu/updateScheduledTime', this.timeStamp);
      this.$store.commit('Menu/updateScheduledEndTime', data.rangeEndTime);
    },
  },
  // eslint-disable-next-line vue/order-in-components
  beforeDestroy() {
    this.resetDate();
  },
};
</script>

<style lang="scss" scoped>
.service {
  font-family: Montserrat;
  &-head {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    &-r {
      color: $primary;
    }
    &-r,
    &-l {
      font-size: 12px;
    }
  }
  &-value {
    font-size: 16px;
    margin-top: 8px;
  }
}
.types {
  padding: 15px;
  font-family: Montserrat;
  &-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 14px;
  }
  &-close {
    width: 16px;
    height: 16px;
  }
  &-body {
    margin: 20px 0px;
    &-item {
      display: flex;
      align-items: center;
      font-size: 16px;
      & + & {
        margin-top: 20px;
      }
      &.disabled {
        opacity: 0.7;
        pointer-events: none;
      }
    }
    &-icon {
      display: inline-block;
      position: relative;
      width: 20px;
      height: 20px;
      border: 2px solid #d1d5db;
      border-radius: 50%;
      margin-right: 12px;
      &.active {
        border: 2px solid $black;
        &::before {
          content: '';
          position: absolute;
          width: 10px;
          height: 10px;
          background-color: $black;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
        }
      }
    }
  }
  &-footer {
    button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border: none;
      background: $primary;
      outline: none;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
